<template>
  <v-container>
    <h2 style="color:gray">Cài đặt quản lý tác vụ</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12" md="6">
        <v-checkbox
          value="task-manage-view-all-task"
          :label="'Cho phép ' + roleName + ' xem danh sách tất cả công việc'"
          v-model="policies"
          hide-details
          class="ma-0 pa-0"
          @change="viewAllTaskOptionChange"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="policies"
          hide-details
          class="ma-0 pa-0"
          value="task-manage-view-related-task"
          :label="'Cho phép ' + roleName + ' xem danh sách công việc liên quan'"
          @change="viewRelatedTaskOptionChange"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="policies"
          hide-details
          class="ma-0 pa-0"
          value="task-manage-add-task"
          :label="'Cho phép ' + roleName + ' thêm công việc'"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="policies"
          hide-details
          class="ma-0 pa-0"
          value="task-manage-update-task"
          :label="'Cho phép ' + roleName + ' cập nhật công việc'"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="policies"
          hide-details
          class="ma-0 pa-0"
          value="task-manage-delete-task"
          :label="'Cho phép ' + roleName + ' xóa công việc'"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="resetPolicies()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'

export default {
  mixins: [mixins],
  methods: {
    viewAllTaskOptionChange() {
      if (this.policies.includes('task-manage-view-all-task')) {
        this.policies = this.policies.filter(p => p !== 'task-manage-view-related-task')
      }
    },
    viewRelatedTaskOptionChange() {
      if (this.policies.includes('task-manage-view-related-task')) {
        this.policies = this.policies.filter(p => p !== 'task-manage-view-all-task')
      }
    },
    save() {
      // Kiểm tra quyền truy cập quản lý công việc
      if (this.policies.filter(p => p !== 'task-manage-access' && p.indexOf('task-manage') !== -1).length > 0) {
        if (!this.policies.includes('task-manage-access')) {
          this.policies.push('task-manage-access')
        }
      } else {
        this.policies = this.policies.filter(p => p !== 'task-manage-access')
      }
      this.$emit('updatePolicies', this.policies)
    }
  }
}
</script>
